import axios from "axios"
import { GET_COURSE_ERROR, GET_COURSE_REQUEST, GET_COURSE_SUCCESS, SINGAL_COURSE_ERROR, SINGAL_COURSE_REQUEST, SINGAL_COURSE_SUCCESS } from "./actiontype"
const baseurl = "https://match-yor-role.onrender.com"
export const  getCourse = (dispatch)=> {
    dispatch({type:GET_COURSE_REQUEST})
    axios.get(`${baseurl}/course`)
    .then((res) => dispatch({type:GET_COURSE_SUCCESS, payload:res.data}))
    .catch((err) => dispatch({type:GET_COURSE_ERROR}))
}

export const  getSingaltCourse = (id)=> (dispatch)=> {
    dispatch({type:SINGAL_COURSE_REQUEST})
    axios.get(`${baseurl}/course/${id}`)
    .then((res) => dispatch({type:SINGAL_COURSE_SUCCESS, payload:res.data}))
    .catch((err) => dispatch({type:SINGAL_COURSE_ERROR}))
}
